module.exports = __webpack_public_path__ + "is.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/is.svg
// module id = 875
// module chunks = 0